import React, { useEffect, useState } from "react";
import "./ConfiguracoesMeta.css";

const initialForm = {
  ativo: false,
  pixel_id: "",
  access_token: "",
  test_event_code: "",
  lead_ativo: true,
  contact_ativo: true,
  schedule_ativo: true,
  purchase_ativo: true,
  purchase_valor_padrao: "0.00",
};

function Toggle({ checked, onChange, children }) {
  return (
    <label className="meta-capi-toggle-row">
      <button
        type="button"
        className={`meta-capi-switch ${checked ? "is-on" : ""}`}
        onClick={() => onChange(!checked)}
        aria-pressed={checked}
      >
        <span />
      </button>
      <span>{children}</span>
    </label>
  );
}

export default function ConfiguracoesMeta() {
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [message, setMessage] = useState("");
  const [tokenMask, setTokenMask] = useState("");

  useEffect(() => {
    carregar();
  }, []);

  async function carregar() {
    setLoading(true);
    setMessage("");

    try {
      const res = await fetch("/crm-wly/api/meta/config_get.php", {
        credentials: "include",
      });
      const data = await res.json();

      if (!data.success) {
        throw new Error(data.error || "Erro ao carregar configuração.");
      }

      setForm({
        ...initialForm,
        ativo: Number(data.integracao?.ativo || 0) === 1,
        pixel_id: data.integracao?.pixel_id || "",
        access_token: "",
        test_event_code: data.integracao?.test_event_code || "",
        lead_ativo: Number(data.eventos?.lead_ativo || 0) === 1,
        contact_ativo: Number(data.eventos?.contact_ativo || 0) === 1,
        schedule_ativo: Number(data.eventos?.schedule_ativo || 0) === 1,
        purchase_ativo: Number(data.eventos?.purchase_ativo || 0) === 1,
        purchase_valor_padrao: data.eventos?.purchase_valor_padrao || "0.00",
      });
      setTokenMask(data.integracao?.access_token_mask || "");
    } catch (err) {
      setMessage(err.message || "Erro ao carregar configuração.");
    } finally {
      setLoading(false);
    }
  }

  function update(name, value) {
    setForm((old) => ({ ...old, [name]: value }));
  }

  async function salvar(e) {
    e.preventDefault();
    setSaving(true);
    setMessage("");

    try {
      const res = await fetch("/crm-wly/api/meta/config_save.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
        ...form,
        contact_min_mensagens: 2,
        schedule_funil: "Agendado",
        purchase_funil: "Cliente",
      }),
      });
      const data = await res.json();

      if (!data.success) {
        throw new Error(data.error || "Erro ao salvar configuração.");
      }

      setMessage("Configuração salva com sucesso.");
      await carregar();
    } catch (err) {
      setMessage(err.message || "Erro ao salvar configuração.");
    } finally {
      setSaving(false);
    }
  }

  async function testar(eventName) {
    setTesting(true);
    setMessage("");

    try {
      const res = await fetch("/crm-wly/api/meta/testar_evento.php", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ event_name: eventName }),
      });
      const data = await res.json();

      if (!data.success) {
        throw new Error(data.error || "Erro ao enviar evento de teste.");
      }

      setMessage(`Evento de teste ${eventName} enviado. HTTP ${data.http_code}.`);
    } catch (err) {
      setMessage(err.message || "Erro ao enviar evento de teste.");
    } finally {
      setTesting(false);
    }
  }

  if (loading) {
    return <div style={{ padding: 24 }}>Carregando integração Meta...</div>;
  }

  return (
  <div className="meta-capi-page">
    <div className="meta-capi-header">
      <h1>Integração Meta CAPI</h1>
      <p>
        Configure o Pixel/Dataset da Meta para enviar eventos do Nórea CRM via
        Conversions API.
      </p>
    </div>

    {message && <div className="meta-capi-alert">{message}</div>}

    <form onSubmit={salvar} className="meta-capi-form">
      <section className="meta-capi-card">
        <div className="meta-capi-card-title-row">
          <h2>Credenciais</h2>
          <Toggle checked={form.ativo} onChange={(v) => update("ativo", v)}>
            Integração ativa
          </Toggle>
        </div>

        <label className="meta-capi-label">
          Pixel ID / Dataset ID
          <input
            className="meta-capi-input"
            type="text"
            value={form.pixel_id}
            onChange={(e) => update("pixel_id", e.target.value)}
            placeholder="Ex: 123456789000000"
          />
        </label>

        <label className="meta-capi-label">
          Access Token {tokenMask ? `(atual: ${tokenMask})` : ""}
          <textarea
            className="meta-capi-input meta-capi-textarea"
            value={form.access_token}
            onChange={(e) => update("access_token", e.target.value)}
            placeholder={
              tokenMask
                ? "Deixe vazio para manter o token atual"
                : "Cole o token da Meta aqui"
            }
            rows={3}
          />
        </label>

        <label className="meta-capi-label meta-capi-test-code-label">
          <span className="meta-capi-label-with-help">
            Código de teste
            <span
              className="meta-capi-help"
              title="Esse código é encontrado na Meta, nas configurações do Gerenciador de Eventos, na área de eventos de teste."
            >
              !
            </span>
          </span>

          <input
            className="meta-capi-input meta-capi-input-test-code"
            type="text"
            value={form.test_event_code}
            onChange={(e) => update("test_event_code", e.target.value)}
            placeholder="Ex: TEST12345"
          />
        </label>
      </section>

      <section className="meta-capi-card">
        <h2>Eventos</h2>

        <div className="meta-capi-event-row">
          <div>
            <Toggle checked={form.lead_ativo} onChange={(v) => update("lead_ativo", v)}>
              Enviar Lead quando o lead for criado
            </Toggle>
            <p>Dispara automaticamente quando um novo lead entra no CRM.</p>
          </div>

          <button
            type="button"
            disabled={testing}
            onClick={() => testar("Lead")}
            className="meta-capi-btn meta-capi-btn-secondary"
          >
            Testar Lead
          </button>
        </div>

        <div className="meta-capi-event-row">
          <div>
            <Toggle checked={form.contact_ativo} onChange={(v) => update("contact_ativo", v)}>
              Enviar Contact na segunda mensagem recebida
            </Toggle>
            <p>O evento será enviado quando o lead atingir 2 mensagens de entrada.</p>
          </div>

          <button
            type="button"
            disabled={testing}
            onClick={() => testar("Contact")}
            className="meta-capi-btn meta-capi-btn-secondary"
          >
            Testar Contact
          </button>
        </div>

        <div className="meta-capi-event-row">
          <div>
            <Toggle checked={form.schedule_ativo} onChange={(v) => update("schedule_ativo", v)}>
              Enviar Schedule
            </Toggle>
            <p>O evento será enviado quando o lead virar <strong>Agendado</strong> no funil.</p>
          </div>

          <button
            type="button"
            disabled={testing}
            onClick={() => testar("Schedule")}
            className="meta-capi-btn meta-capi-btn-secondary"
          >
            Testar Schedule
          </button>
        </div>

        <div className="meta-capi-event-row">
          <div>
            <Toggle checked={form.purchase_ativo} onChange={(v) => update("purchase_ativo", v)}>
              Enviar Purchase
            </Toggle>
            <p>O evento será enviado quando o lead virar <strong>Cliente</strong> no funil.</p>
          </div>

          <button
            type="button"
            disabled={testing}
            onClick={() => testar("Purchase")}
            className="meta-capi-btn meta-capi-btn-secondary"
          >
            Testar Purchase
          </button>
        </div>

        <label className="meta-capi-label">
          Valor padrão do Purchase
          <input
            className="meta-capi-input meta-capi-input-small"
            type="number"
            step="0.01"
            value={form.purchase_valor_padrao}
            onChange={(e) => update("purchase_valor_padrao", e.target.value)}
          />
        </label>
      </section>

      <div className="meta-capi-actions">
        <button
          type="submit"
          disabled={saving}
          className="meta-capi-btn meta-capi-btn-primary"
        >
          {saving ? "Salvando..." : "Salvar configuração"}
        </button>
      </div>
    </form>
  </div>
);
}
